import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const AfterSubmission = () => {
  return (
    <Container>
      <h2 className="display-6 fw-bold my-4">After submission</h2>
      <hr />

      <p className="joab-common-para my-2 ">
        The first stage for a newly submitted Article is that the editorial
        staff consider whether to send it for peer-review.
      </p>
    </Container>
  );
};

export default AfterSubmission;
